import * as React from "react";
import "./DetailToggle.css";
import {ModelControler} from "../../../service/modelController";
import { ImageSoucre } from "../../../service/ImageSource";
import { PriceService } from "../../../service/PriceService";

export let details =[
    {
        detailID:"toggle-grilldeckel",
        parentToggle:"Grilldeckel",
        featureName:"Grilldeckel",
        ref:null
    },
    {
        detailID:"toggle-unterschrank",
        parentToggle:"Unterschrank",
        featureName:"Unterschrank",
        ref:null
    },
    {
        detailID:"toggle-gasflaschenhalter",
        parentToggle:"Gasflaschenhalter",
        featureName:"Gasflaschenhalter",
        ref:null
    },
    {
        detailID:"toggle-drehspieß",
        parentToggle:"Drehspieß",
        featureName:"Drehspieß",
        ref:null
    },
    {
        detailID:"toggle-tischbrenner-seitenablage",
        parentToggle:"Seitenablage",
        featureName:"Tischbrenner-Seitenablage",
        ref:null
    },
    {
        detailID:"toggle-tischbrenner-seitenablage",
        parentToggle:"Tischbrenner",
        featureName:"Tischbrenner-Seitenablage",
        ref:null
    }
    // {
    //     detailID:"toggle-schutzhaube",
    //     parentToggle:"Schutzhaube",
    //     ref:null
    // }
]

interface DetailProps {
    //name:string;
    detailID:string,
    featureName:string,
    parentToggle:string,
    renderVisibility:()=>void,
    playAnimation:(s:string)=>void
}

interface DetailState{
    isVisible:boolean,
    imagePath:any
}

export class DetailToggle extends React.Component<DetailProps, DetailState>{
    constructor(props:DetailProps){
        super(props);
        this.state = {
            isVisible: false,
            imagePath: ModelControler.instance.getFeature(this.props.featureName).getImagePath()
        }
    }
    componentDidMount() {
        PriceService.instance.priceObserve.addListener('priceChange', () => {this.setState({
            imagePath: ModelControler.instance.getFeature(this.props.featureName).getImagePath()}
            )});
    }
    
    public toggleVisible():Promise<any>{
        let newValue = !this.state.isVisible;
        this.setState({isVisible:newValue});
        details.forEach((e)=>{
            if(e.parentToggle != this.props.parentToggle){
                e.ref.turnOffVisibility();
            }
        })
        return new Promise(resolve => {
            resolve();
        })
    }

    public turnOffVisibility(){
        this.setState({isVisible:false});
    }

    public getVisibility():boolean{
        return this.state.isVisible;
    }

    styleHidden = {
        visibility:"hidden"
    }

    toggleFeature(){
        ModelControler.instance.toggleFeature(this.props.featureName, this.props.parentToggle);
        this.setState({
            imagePath: ModelControler.instance.getFeature(this.props.featureName).getImagePath()
        })
        this.props.renderVisibility();
    }

    hasAnimation():boolean{
        return ModelControler.instance.getFeature(this.props.featureName).getHasAnim();
    }

    render(){
        if(this.state.isVisible){
            if(this.hasAnimation()){
                return(
                    <div className="buttons-top">
                        <div className="button-image-wrapper" /*onClick={this.toggleFeature.bind(this)}*/>
                            <img id="unterschrank-selected" src={this.state.imagePath} alt="Unterschrank selected"/>
                        </div>
                        <div className="play-animation-button" onClick={()=>{this.props.playAnimation(this.props.featureName === "Grilldeckel"? "Deckel":"Schrank")}}>
                            <img className="play-image" src={require('../../../img/Play.png')} alt="Play animation"/>
                        </div>
                    </div>
                )
            }
            else{
                return(
                    <div className={"buttons-top"}>
                        <div className="button-image-wrapper" /*onClick={this.toggleFeature.bind(this)}*/>
                            <img id="unterschrank-selected" className="buttons-top-margin-left" src={this.state.imagePath} alt="Unterschrank selected"/>
                        </div>
                    </div>
                )
            }
            
        }
        else{
            return(
                <div className="buttons-top" style={this.styleHidden}>
                    <div className="button-image-wrapper"></div>
                    <div className="play-animation-button"></div>
                </div>
            )
        }
    }
}